<template>
    <label :for="'diploma_' + itemKey" class="radioFrame" :class="{ 'selected' : selected === itemKey }">
        <input input type="radio" :id="'diploma_' + itemKey" name="range" :value="itemKey" v-model="targetDiploma" @change="isSelected()">
        <span>{{ diploma }}</span>
    </label>
</template>

<script>
export default {
    name: 'RadioDiploma',
    props: {
        diploma: {
            type: String,
            required: true
        },
        itemKey: {
            type: Number,
            required: true
        },
        selected: {
            type: Number,
            required: false
        }
    },
    data () {
        return {
            targetDiploma: null
        }
    },
    methods: {
        isSelected () {
            this.$store.state.diploma = this.targetDiploma
        }
    }
}
</script>

<style lang="scss" scoped>
    .radioFrame {
        accent-color: var(--color-secondary);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 19px 20px 18px 20px;
        border: solid 1px #B3BAC5;
        border-radius: 12px;
        width: calc(100% - 22px + 20px - 31px - 11px);
        margin-bottom: 12px;
        cursor: pointer;
        input {
            width: 20px;
            height: 20px;
            margin: 0;
            cursor: pointer;
        }
        span {
            margin: unset;
            margin-left: 20px;
            text-align: left;
            font-weight: 700;
            font-size: 16px;
            letter-spacing: 0.38px;
            color: var(--color-text);
            width: 100%;
        }
    }
    .selected {
        border: solid 2px var(--color-secondary);
        border-radius: 12px;
        background-color: #F4E8EF;
        box-shadow: 0 9px 12px -10px #253568;
        input:after {
            content: '';
            position: absolute;
            margin-top: 1.5px;
            width: 17px;
            height: 17px;
            border-radius: 50%;
            background-color: var(--color-secondary);
            background-image: url('../../public/assets/icon/check.svg');
            background-position: 60% 50%;
            background-size: 65%;
            background-repeat: no-repeat;
        }
    }
</style>